export const laboratoryEn = {
 "Laboratoires": "Laboratories", 
 "Docteur": "Doctor",
 "Patient": "Patient",
 "Prix du lab": "Lab Price",
 "Comptes": "Accounts",
 "Consommations": "Consumptions",
 "Date D'empreinte": "Date of imprint",
 "Date RDV": "Appointment Date",
 "Patient Non Terminer": "Patient not finished",
 "Comment": "Comment",
 "Prix": "Price",

  // Server side 

  "Le laboratoire deja existe.": "The laboratory already exists.",
  "Le nom du laboratoire est obligatoire !!": "The name of the laboratory is mandatory!!",
  "Le docteur est obligatoire": "The doctor is mandatory",
  "Le montant est obligatoire": "The amount is mandatory",
  "le traitement deja existe": "the treatment already exists",
  "Donner le traitement": "Give the treatment",
  "Donner le prix": "Give the price",


}